import Vuex from 'vuex';
import Vue from 'vue';
import { getData, db } from "./firebase";
import { getDoc, doc } from "firebase/firestore";

Vue.use(Vuex);

export default new Vuex.Store({
    state () {
        return {
            vessels: [],
            vesselsByType: [],
            customers: [],
            members: [],
            careers: [],
            press: [],
            contacts: [],
            about: '',
            numbers: null,
            policy: '',
            policyTitle: '',
            shipRecycling: '',
            shipRecyclingTitle: ''
        }
    },
    mutations: {
        setVessels (state, val) {
            state.vessels = val;
        },
        setVesselsByType (state, val) {
            state.vesselsByType = val;
        },
        setCustomers (state, val) {
            state.customers = val;
        },
        setMembers (state, val) {
            state.members = val;
        },
        setCareers (state, val) {
            state.careers = val;
        },
        setPress (state, val) {
            state.press = val;
        },
        setContacts (state, val) {
            state.contacts = val;
        },
        setAbout (state, val) {
            state.about = val;
        },
        setNumbers (state, val) {
            state.numbers = val;
        },
        setPolicyTitle (state, val) {
            state.policyTitle = val;
        },
        setPolicyText (state, val) {
            state.policy = val;
        },
        setShipRecyclingTitle (state, val) {
            state.shipRecyclingTitle = val;
        },
        setShipRecyclingText (state, val) {
            state.shipRecycling = val;
        },
    },
    getters: {
        orderedCustomers: state => {
            return state.customers.filter((c) => c.visible).sort((a, b) => a.orderId - b.orderId);
        },
        firstCustomers: state => {
            return state.customers.filter((c) => c.visible).sort((a, b) => a.orderId - b.orderId).slice(0, 6);
        },
        orderedMembers: state => {
            return state.members.filter((c) => c.visible).sort((a, b) => a.orderId - b.orderId);
        },
        orderedPress: state => {
            return state.press.filter((c) => c.visible).sort((a, b) => (a.orderId - b.orderId) * -1);
        },
        orderedCareers: state => {
            return state.careers.filter((c) => c.visible).sort((a, b) => (a.orderId - b.orderId) * -1);
        },
        orderedContacts: state => {
            return state.contacts.sort((a, b) => a.orderId - b.orderId);
        }
    },
    actions: {
        async getAboutUs (context) {
            getDoc(doc(db, "common", "aboutus")).then((aboutSnap) => {
                context.commit('setAbout', aboutSnap.data().content);
            });
        },
        async getVesselsByType (context) {
            getData('vesselsByType').then((vessels) => {
                context.commit('setVesselsByType', vessels);
            });
        },
        async getData (context) {
            getDoc(doc(db, "common", "numbers")).then((numbersSnap) => {
                context.commit('setNumbers', numbersSnap.data());
            });

            // getData('vessels').then((vessels) => {
            //     context.commit('setVessels', vessels);
            // });

            getData('vesselsByType').then((vessels) => {
                context.commit('setVesselsByType', vessels);
            });

            getData('customers').then((clients) => {
                context.commit('setCustomers', clients);
            });

            getData('members').then((members) => {
                context.commit('setMembers', members);
            });

            getData('careers').then((careers) => {
                context.commit('setCareers', careers);
            });

            getData('press').then((press) => {
                context.commit('setPress', press);
            });

            getData('contacts').then((contacts) => {
                context.commit('setContacts', contacts);
            });

            getDoc(doc(db, "common", "policy")).then((policySnap) => {
                context.commit('setPolicyText', policySnap.data().content);
                context.commit('setPolicyTitle', policySnap.data().title);
            });

            getDoc(doc(db, "common", "shipRecycling")).then((shipRecyclingSnap) => {
                context.commit('setShipRecyclingText', shipRecyclingSnap.data().content);
                context.commit('setShipRecyclingTitle', shipRecyclingSnap.data().title);
            });
        }
    }
});